import axios from 'axios'

const Base_url = 'https://api.tradexsecurities.in/api/admin'; // 'https://api.onestocks.in/api/admin';// 'http://82.112.227.84/api/admin';
const Api = axios.create({
    baseURL: Base_url,
    headers: {
        'Accept': 'application/json',
        // Authorization: `Bearer ${sessionStorage.getItem('authtoken')}`
    }
});


Api.interceptors.request.use(config => {
    const token = localStorage.getItem('authtoken');
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
    } else {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
}, error => {
    return Promise.reject(error);
});
const ApiService = {
    // getSettingData: (key) => Api.get('get-setting-data',{params:{key}}),
        login : (data) => Api.post('/login',data),
        getAdmin : () => Api.get('/getadmin'),
        updatepassword : (data) => Api.post('/updateProfile',data),
        manageSettings : (data) => Api.post('/manageSettings',data),
        getAllSettings : (params) => Api.get('/getAllSettings',{params:params}),
        userlist : (params) => Api.get('/userlist',{params}),
        deleteuserlist : (params) => Api.get('/deleteuserlist',{params}),
        userlistForcreateOrder : () => Api.get('/userlistForcreateOrder'),
        createOrder : (data) => Api.post('/createOrder',data),
        updateOrder : (id,data) => Api.post(`/updateOrder/${id}`,data),
        orderList : (params) => Api.get('/orderList',{params:params}),
        withdrawList : (params) => Api.get('/withdrawrequestlist',{params}),
        withdrawStatusUpdate : (data) => Api.post('/withdrawStatusUpdate',data),
        userDetails : (params) => Api.get('/userDetails',{params}),
        updateStatusUser : (data) => Api.post('/updateStatusUser',data),
        deleteOrder : (data) => Api.delete('/deleteOrder',{data}),
        createfaq : (data) => Api.post('/createfaq',data),
        updatefaqs : (data) => Api.put('/updatefaqs',data),
        getFaq : () => Api.get('/getFaq'),
        faqbyid : (params) => Api.get('/faqbyid',{params}),
        updateOrderstatus : (data) => Api.post('/orderStatusupdate',data),
        edituserfunds : (data) => Api.post('/edituserfunds',data),
        deleteUser : (userId) => Api.delete(`/deleteUser/${userId}`),
        addbankdetails : (data) => Api.post('/AddOrUpdateBankDetails',data),
        paymentStatus : (data) => Api.post('/paymentStatus',data),
        getBankDetails : () => Api.get('/getBankDetails'),
        paymentlist : (params) => Api.get('/paymentlist',{params}),
        createNotification : (data) => Api.post('/createNotification',data),
        getDashboard : () => Api.get('/getDashboard'),
        createStockCategory : (data) => Api.post('/createStockCategory',data),
        getStockCategory : (params) => Api.get('/getCategory',{params}),
        getStockCategoryById : (params) => Api.get('/getCategoryById',{params}),
        updateStockCategory : (data) => Api.post('/updateCategory',data),
        deleteStockCategory : (id) => Api.delete(`/deleteCategory/${id}`),
        createStocks : (data) => Api.post('/createStocks',data),
        getAllStocks : () => Api.get('/getAllStocks'),
        getStockById : (id) => Api.get(`/getStockById/${id}`),
        deleteStock : (id) => Api.delete(`/deleteStock/${id}`),
        updateStock : (id,data) => Api.post(`/updateStock/${id}`,data),
        updateUser : (id,data) => Api.post(`/editUser/${id}`,data),
        toggleFeatured : (id) => Api.post(`/featured-category/${id}`),


        

      
        

        

};

export default ApiService;